"use client"

import React, { Suspense, useEffect } from 'react'
import dynamic from 'next/dynamic'
import IdleMount from '@/components/IdleMount'

declare global {
  interface Window {
    __letSuppressAppendChildHandler?: (event: ErrorEvent) => void
  }
}

const shouldSuppressAppendChildError = (message?: string) =>
  typeof message === 'string' && message.includes("Failed to execute 'appendChild'")

if (typeof window !== 'undefined') {
  if (window.__letSuppressAppendChildHandler) {
    window.removeEventListener('error', window.__letSuppressAppendChildHandler, true)
  }

  const handler = (event: ErrorEvent) => {
    if (!shouldSuppressAppendChildError(event.message)) return
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
  }

  window.addEventListener('error', handler, true)
  window.__letSuppressAppendChildHandler = handler
}

// Dynamic imports (client-only) without ssr:false at layout level
const AnalyticsLazy = dynamic(() => import('@/components/AnalyticsClient'))
const PopupProviderLazy = dynamic(() => import('@/components/popup-provider'))

export default function DeferredClient() {
  useEffect(() => {
    return () => {
      if (typeof window === 'undefined') return
      if (window.__letSuppressAppendChildHandler) {
        window.removeEventListener('error', window.__letSuppressAppendChildHandler, true)
        delete window.__letSuppressAppendChildHandler
      }
    }
  }, [])

  return (
    <>
      <Suspense fallback={null}>
        <IdleMount delay={1500}>
          <AnalyticsLazy />
        </IdleMount>
      </Suspense>
      <IdleMount delay={2000}>
        <PopupProviderLazy />
      </IdleMount>
    </>
  )
}
